import * as React from 'react';
const TransparentLocator = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#003594"
        d="M12 21.5c-1.69 0-3.07-.242-4.142-.727-1.072-.485-1.608-1.112-1.608-1.879 0-.355.134-.689.401-1.002.267-.313.637-.581 1.109-.805l1.18 1.07c-.214.087-.439.194-.675.322-.236.128-.397.263-.484.405.165.3.657.56 1.476.782.818.223 1.731.334 2.738.334s1.924-.111 2.751-.334c.827-.222 1.323-.483 1.489-.782-.085-.152-.256-.292-.513-.42a7.6 7.6 0 0 0-.731-.322l1.165-1.086c.511.234.905.508 1.18.821.276.313.414.65.414 1.013 0 .768-.536 1.396-1.608 1.881-1.072.486-2.452.729-4.142.729Zm.025-4.875c1.656-1.255 2.9-2.498 3.73-3.73.83-1.231 1.245-2.454 1.245-3.668 0-1.726-.54-3.028-1.62-3.908C14.3 4.44 13.175 4 12.005 4s-2.297.44-3.38 1.32C7.542 6.2 7 7.503 7 9.23c0 1.134.41 2.31 1.23 3.528.82 1.218 2.085 2.507 3.795 3.867ZM12 18.5c-2.182-1.631-3.811-3.216-4.886-4.754C6.037 12.21 5.5 10.703 5.5 9.229c0-1.113.197-2.089.59-2.926.393-.837.9-1.538 1.522-2.103a6.338 6.338 0 0 1 2.092-1.273 6.63 6.63 0 0 1 2.297-.426c.758 0 1.524.142 2.296.426.772.284 1.47.708 2.091 1.273.622.565 1.13 1.266 1.522 2.104.393.837.59 1.812.59 2.924 0 1.475-.538 2.981-1.613 4.519C15.81 15.283 14.182 16.868 12 18.5Zm.005-7.606c.495 0 .92-.175 1.273-.525.353-.35.53-.776.53-1.278s-.177-.93-.531-1.282A1.743 1.743 0 0 0 12 7.279c-.492 0-.917.177-1.273.53-.357.355-.535.78-.535 1.277 0 .506.178.933.535 1.283.356.35.782.525 1.278.525Z"
      />
    </g>
  </svg>
);
export default TransparentLocator;
